import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './bubble.svg'
import _imports_1 from './xpolar.svg'
import _imports_2 from './polar-fancy.svg'
import _imports_3 from './near.svg'


_pushScopeId("data-v-bcee1a52")
const _hoisted_1 = { class: "vex-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("div", { class: "title-text" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createTextVNode("Extra earnings "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("& voting power")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "flex gap-[28px] justify-center mt-[16px]" }, [
      /*#__PURE__*/_createElementVNode("button", { class: "get-btn" }, "Get VexPolar"),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://medium.com/@PolarisFinance/polaris-dex-917e45c4869c",
        target: "_blank",
        class: "learn-btn"
      }, "Learn More")
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title mt-[160px]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title-text" }, " Coming soon... ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, [
    /*#__PURE__*/_createTextVNode(" Boost liquidity mining"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" yield up to 2.5x ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "info-token" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-[124px]",
      src: _imports_1
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "info-subtitle" }, "XPOLAR")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, [
    /*#__PURE__*/_createTextVNode(" Vote to direct liquidity "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" mining emissions ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "info-token" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-[124px]",
      src: _imports_2
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "info-subtitle" }, "SPOLAR")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, [
    /*#__PURE__*/_createTextVNode(" Earn your share of "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" protocol revenue ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "info-token" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-[124px]",
      src: _imports_3
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "info-subtitle" }, "NEAR")
], -1)
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "my-vexpolar" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "my-vexpolar-title" }, "My VexPolar", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"my-vexpolar-element\" data-v-bcee1a52><div class=\"my-vexpolar-element-title\" data-v-bcee1a52>My VexPolar</div><div class=\"my-vexpolar-element-price\" data-v-bcee1a52>$ USD</div><div class=\"my-vexpolar-element-token\" data-v-bcee1a52>My VexPolar</div></div><div class=\"my-vexpolar-element\" data-v-bcee1a52><div class=\"my-vexpolar-element-title\" data-v-bcee1a52>My VexPolar</div><div class=\"my-vexpolar-element-price\" data-v-bcee1a52>$ USD</div><div class=\"my-vexpolar-element-token\" data-v-bcee1a52>My VexPolar</div></div><div class=\"my-vexpolar-element\" data-v-bcee1a52><div class=\"my-vexpolar-element-title\" data-v-bcee1a52>My VexPolar</div><div class=\"my-vexpolar-element-price\" data-v-bcee1a52>$ USD</div><div class=\"my-vexpolar-element-token\" data-v-bcee1a52>My VexPolar</div></div><div class=\"my-vexpolar-element\" data-v-bcee1a52><div class=\"my-vexpolar-element-title\" data-v-bcee1a52>My VexPolar</div><div class=\"my-vexpolar-element-price\" data-v-bcee1a52>$ USD</div><div class=\"my-vexpolar-element-token\" data-v-bcee1a52>My VexPolar</div></div>", 4)
const _hoisted_15 = [
  _hoisted_11
]
const _hoisted_16 = {
  key: 0,
  class: "mt-[56px] mx-[24px]"
}
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"pools-eligible\" data-v-bcee1a52>Pools eligible for liquidity mining</div><div class=\"content mt-[32px]\" data-v-bcee1a52> Liquidity incentives are directed by the community of veBAL holders. If you hold veBAL, vote below on any pools across Ethereum and Layer 2’s. Your vote will persist until you change it and editing a pool can only be done once in 10 days. </div><div class=\"pools-subtitle mt-[32px]\" data-v-bcee1a52>My unallocated votes</div><div class=\"pools-content mt-[24px]\" data-v-bcee1a52>-</div><div class=\"pools-subtitle mt-[32px]\" data-v-bcee1a52>Voting period ends</div><div class=\"pools-content mt-[24px\" data-v-bcee1a52>6d : 6h : 56m : 19s</div>", 6)
const _hoisted_23 = [
  _hoisted_17
]
const _hoisted_24 = { class: "table mt-[144px]" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "table-title" }, "Pools", -1)
const _hoisted_26 = {
  key: 0,
  class: "table-head"
}
const _hoisted_27 = { class: "flex gap-[12px]" }
const _hoisted_28 = ["src"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, "Tokens", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", null, "Composition", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", null, "Next Period Votes", -1)
const _hoisted_32 = {
  key: 1,
  class: "table-head-mobile"
}
const _hoisted_33 = { class: "flex gap-[12px]" }
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", null, "Tokens & Composition", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", null, "Next Votes", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1)
const _hoisted_38 = { class: "mt-[24px]" }
const _hoisted_39 = {
  key: 0,
  class: "text-left"
}
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", null, "-", -1)
_popScopeId()

import useBreakpoints from '@/composables/useBreakpoints';
import segniorageImg from './segniorage.svg';
import { POOLS } from '@/constants/pools';
import { PoolWithShares } from '@/services/pool/types';

import {
  orderedPoolTokens,
  orderedTokenAddresses,
} from '@/composables/usePool';

import usePoolFilters from '@/composables/pools/usePoolFilters';
import useStreamedPoolsQuery from '@/composables/queries/useStreamedPoolsQuery';


export default _defineComponent({
  setup(__props) {

const { isDesktop, isMobile } = useBreakpoints();

const { selectedTokens, addSelectedToken, removeSelectedToken } =
  usePoolFilters();

console.log(POOLS);

const {
  dataStates,
  result: investmentPools,
  loadMore,
  isLoadingMore,
} = useStreamedPoolsQuery(selectedTokens);

function iconAddresses(pool: PoolWithShares) {
  return POOLS.Metadata[pool.id]?.hasIcon
    ? [pool.address]
    : orderedTokenAddresses(pool);
}

return (_ctx: any,_cache: any) => {
  const _component_BalAssetSet = _resolveComponent("BalAssetSet")!
  const _component_TokenPills = _resolveComponent("TokenPills")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'pg-bg': _unref(isDesktop) })
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass({ 'relative': _unref(isDesktop) })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", {
          class: _normalizeClass([{
          'info-container': _unref(isDesktop),
          'info-container-mobile': _unref(isMobile),
        }, "mt-[160px]"])
        }, _hoisted_7, 2),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("div", {
            class: _normalizeClass({
            'my-vexpolar-table': _unref(isDesktop),
            'my-vexpolar-table-mobile': _unref(isMobile),
          })
          }, _hoisted_15, 2)
        ]),
        (_unref(isMobile))
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_23))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          (_unref(isDesktop))
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("img", { src: _unref(segniorageImg) }, null, 8, _hoisted_28),
                  _hoisted_29
                ]),
                _hoisted_30,
                _hoisted_31
              ]))
            : _createCommentVNode("", true),
          (_unref(isMobile))
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("img", { src: _unref(segniorageImg) }, null, 8, _hoisted_34),
                  _hoisted_35
                ]),
                _hoisted_36
              ]))
            : _createCommentVNode("", true),
          _hoisted_37,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(investmentPools), (pool, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex justify-between items-center",
              key: idx
            }, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_BalAssetSet, {
                  size: 36,
                  addresses: iconAddresses(pool),
                  width: 100
                }, null, 8, ["addresses"])
              ]),
              (_unref(POOLS).Metadata[pool.id])
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(POOLS).Metadata[pool.id].name), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createVNode(_component_TokenPills, {
                      tokens: 
                _unref(orderedPoolTokens)(pool.poolType, pool.address, pool.tokens)
              ,
                      isStablePool: false,
                      selectedTokens: _unref(selectedTokens),
                      showWeight: pool['poolType'] != 'Stable'
                    }, null, 8, ["tokens", "selectedTokens", "showWeight"])
                  ])),
              _hoisted_41
            ]))
          }), 128))
        ])
      ])
    ], 2)
  ], 64))
}
}

})